<template>
  <v-dialog v-model="error" width="500">
    <v-card>
      <v-card-title
        class="headline red lighten-1"
        style="color: white;"
        primary-title
      >
        Oops!
      </v-card-title>

      <v-card-text>
        {{ errorMessage }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <bxp-button color="lightgrey" @click="closeDialog">
          OK
        </bxp-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    computed: {
      error: {
        get() {
          return this.$formFrameworkOptions.formBus.error;
        },
        set(val) {
          this.$formFrameworkOptions.formBus.error = val;
        }
      },
      errorMessage: {
        get() {
          return this.$formFrameworkOptions.formBus.errorMessage;
        },
        set(val) {
          this.$formFrameworkOptions.formBus.errorMessage = val;
        }
      }
    },
    methods: {
      closeDialog() {
        this.$formFrameworkOptions.formBus.error = false;
        this.$formFrameworkOptions.formBus.errorMessage = "";
      }
    }
  }
</script>

<style>


</style>
